import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const SuccessAndComplitionCharts = ({ value = 0, total = 100,}: any) => {
    const clampedValue = Math.max(0, Math.min(100, value || 0));
    
    const getColorForValue = (val: number): string => {
        if (val < 20) return '#E97389';
        if (val < 40) return '#FF7539';
        if (val < 60) return '#F5A623';
        if (val < 80) return '#64ADF0';
        return '#23CF95';
    };
    
    const segmentColor = getColorForValue(clampedValue);
    
    const data = {
        datasets: [
            {
                data: [clampedValue, total - clampedValue],
                backgroundColor:[segmentColor, '#FFFFFF'],
                borderWidth: [1.5, 1.5],
                borderColor: [segmentColor, segmentColor],
                cutout: '80%',
                spacing: 4,
            },
        ],
    };

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,

        hover: {
            mode: null,
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
    };

    return (

        <div style={{ position: 'relative', width: '10rem', height: '80%' }}>
            <Doughnut data={data} options={options} />
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                }}
            >
                <p className='m-0 text-3xl ' style={{ color: "#2D3967",fontWeight: "bold" }}>{Math.round(clampedValue)}%</p>

            </div>
        </div>

    );
};

export default SuccessAndComplitionCharts;
